var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dialog-host"},_vm._l((_vm.stack),function(item){return _c(_vm.resolveDialog(item.type),_vm._b({key:item.id,tag:"component",on:{"resolve":function($event){return _vm.onResolve(item.id, $event)},"reject":function($event){return _vm.onReject(item.id, $event)}}},'component',item.props,false))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }